<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h4 class="secondary--text mb-3">
          {{
            $t(
              'fleet_management.geofences.create_geofence.labels.form_sub_title'
            )
          }}
        </h4>
        <h5 class="tertiary--text">
          {{
            $t(
              'fleet_management.geofences.create_geofence.labels.coordinates_polygon_hint'
            )
          }}
        </h5>
      </v-col>
      <v-col align-self="center" class="text-right">
        <v-btn
          @click="resetPolygon"
          outlined="true"
          color="secondary"
          rounded
          >{{
            $t(
              'fleet_management.geofences.create_geofence.labels.form_new_geofence_reset_button'
            )
          }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { i18n } from '@leapsight/portal'
import { GeofencesHelpers, MapHelpers } from '@/helpers/mainExports.js'
import { mapActions } from 'vuex'

export default {
  name: 'PolygonZone',

  data() {
    return {
      polygon: null,
      coordinates: []
    }
  },
  methods: {
    resetPolygon() {
      this.polygon.setMap(null)
      this.polygon = new google.maps.Polygon({
        strokeColor: '#8079b7',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#554da0',
        editable: true,
        fillOpacity: 0.35
      })
      this.$emit('resetZone')
    },
    addLatLng(event) {
      const map = GeofencesHelpers.getMap()

      const path = this.polygon.getPath()

      //When we have less than 3 points on the map we create a "polyLine" this because the "polyGone" need 3 point minimun. When we have 3 or more we delete the "Polyline" and create a "polyGone"
      if (path.length == 0) {
        const polygonOptions = {
          path: path,
          strokeColor: '#8079b7',
          editable: true
        }
        this.polygon.setMap(null)
        this.polygon = new google.maps.Polyline(polygonOptions)
        this.polygon.setMap(map)
      } else if (path.length == 2) {
        this.polygon.setMap(null)
        const polygonOptions = {
          path: path,
          strokeColor: '#8079b7',
          fillColor: '#554da0',
          editable: true
        }
        this.polygon = new google.maps.Polygon(polygonOptions)
        this.polygon.setMap(map)
      }

      path.push(event.latLng)
    },
    polygoneEmit() {
      const payload = {
        type: 'Feature',
        geometry: {
          type: 'Polygon',
          coordinates: [this.coordinates]
        },
        properties: {}
      }
      this.$emit('polygonEmit', [payload, true])
    }
  },
  watch: {
    //Every time the mouse get out of the polygon reset the coordinates, this includes when an inner point is moved by the draggable option.
    polygon() {
      const path = this.polygon.getPath()
      if (path.length > 2) {
        google.maps.event.addListener(this.polygon, 'mouseout', () => {
          this.coordinates = []
          for (let i = 0; i < path.length; i++) {
            this.coordinates.push([ path.getAt(i).lng(), path.getAt(i).lat(),])
          }
          this.coordinates.push(this.coordinates[0])
          this.polygoneEmit()
        })
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      const map = GeofencesHelpers.getMap()
      this.polygon = new google.maps.Polygon({
        strokeColor: '#8079b7',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#554da0',
        editable: true,
        fillOpacity: 0.35
      })

      MapHelpers.setMapCenterBaseOnCountryId()

      google.maps.event.addListener(map, 'click', event => {
        this.addLatLng(event)
        // google.maps.event.clearListeners(map, 'click')
      })
    })
  },
  beforeDestroy() {
    this.polygon.setMap(null)
    if (this.polygon !== null) {
    }
    const map = GeofencesHelpers.getMap()
    google.maps.event.clearListeners(map, 'click')
  }
}
</script>

<style></style>
